import { AuthRepository } from "../repositories/AuthRepository";
import { UserEntity } from "../entities/User";

/**
 * Get Current User Use Case
 * Retrieves currently authenticated user
 */
export class GetCurrentUserUseCase {
  constructor(private authRepository: AuthRepository) {}

  /**
   * Execute get current user
   * @returns Current user or null if not authenticated
   */
  execute(): UserEntity | null {
    if (!this.authRepository.isAuthenticated()) {
      return null;
    }

    return this.authRepository.getStoredUser();
  }

  /**
   * Check if user needs Zoho authentication
   */
  needsZohoAuth(): boolean {
    const user = this.execute();
    // client_view role users don't need Zoho authentication
    if (user?.role?.toLowerCase() === "client_view") {
      return false;
    }
    return user !== null && !user.zohoRefreshToken;
  }

  /**
   * Check if user is admin
   */
  isAdmin(): boolean {
    const user = this.execute();
    return user?.role?.toLowerCase() === "admin";
  }

  /**
   * Admin dashboard access (tenant session): Administrator or CFO.
   */
  isAdminOrCfo(): boolean {
    const user = this.execute();
    const r = user?.role?.toLowerCase();
    return r === "admin" || r === "cfo";
  }

  /**
   * Check if user has specific permission
   * Currently, only admin has all permissions
   */
  hasPermission(permission: string): boolean {
    return this.isAdmin();
  }
}
